import { render, staticRenderFns } from "./UploadFormItem.vue?vue&type=template&id=7a55e255&scoped=true&"
import script from "./UploadFormItem.vue?vue&type=script&lang=js&"
export * from "./UploadFormItem.vue?vue&type=script&lang=js&"
import style0 from "./UploadFormItem.vue?vue&type=style&index=0&id=7a55e255&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a55e255",
  null
  
)

export default component.exports